import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import FullMasterTemplate from '@appbase/templates/FullMasterTemplate.vue'
import MigBoardLeftMenuContainer from '@home/containers/YWK_MigBoard/YWK_MigBoardLeftMenuContainer.vue'
import MigBoardContainer from '@home/containers/YWK_MigBoard/YWK_MigBoardContainer.vue'
import api from '@home/api'
import IFrameModal from '@appbase/components/modal/IFrameModal.vue'

@Component({
    components: { FullMasterTemplate, MigBoardLeftMenuContainer, MigBoardContainer },
})
export default class YWK_MigBoard extends Vue {

    ywkBoardList:ywkMigration.board[] = [];
    selectedMenuId:number = 0
    boardName:string = ''

    created(){
        api.ywkboard.getYWKBoard().then(res=>{
            var _nav = res.filter(r=>r.parentMenuId == 0)
            this.setBoardTree(_nav,res)
            this.openFirstBoard(_nav[0])
            this.ywkBoardList = _nav;
        })
    }

    setBoardTree(rtList:ywkMigration.board[],list:ywkMigration.board[]){
        rtList.forEach(n=>{
            n.isOpened = false;
            var _child = list.filter(r=>r.parentMenuId == n.menuId)
            if(_child.length>0){
                n.children = _child
                n.hasChildren = true;
                this.setBoardTree(n.children,list);
            }
            else{
                n.children = [];
                n.hasChildren = false;
            }
        })
    }

    openFirstBoard(list:ywkMigration.board){
        list.isOpened = true;
        if(list.hasChildren){
            this.openFirstBoard(list.children[0])
        }
        if(list.isBoard){
            this.boardName = list.menuName
            this.selectedMenuId = list.menuId
        }
    }

    openClickedMenu(list:ywkMigration.board[], target:ywkMigration.board){
        var idx = list.findIndex(l=>l==target)
        if(idx>-1){
            if(!list[idx].isOpened){
                this.selectedMenuId = list[idx].isBoard? list[idx].menuId : list[idx].children[0].menuId;
                this.boardName = list[idx].isBoard? list[idx].menuName : list[idx].children[0].menuName;
            }
            list[idx].isOpened = !list[idx].isOpened;
        }
        else{
            list.forEach(l=>{
                this.openClickedMenu(l.children,target)
            })
        }
    }

    boardChanged(board:ywkMigration.board){
        if(board.isBoard){
            this.selectedMenuId = board.menuId
            this.boardName = board.menuName
        }
        else{
            this.openClickedMenu(this.ywkBoardList,board)
        }
    }

    openArticle(article:ywkMigration.article){
        let url:string=`${window.location.origin}/cm/gres/YWK_html${article.htmlPath.replace('\\','/')}`
        const modal: appbase.IModalOpenable = this.$refs['modal'] as any
        const options: appbase.TModalInfo<any> = {
          component: IFrameModal,
          props: {title: this.boardName, src:url, mStyle:'width: 900px; height: 700px'},
          events: {
            cancel: () => {
              modal.closeModal()
            },
          },
        }
        modal.openModal(options)
    }
}
